import { AccountSummaryModel, IUserData, IUserManager, UserModel, UserStatus } from '@truckdown/accounts';
import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, computed, onMounted, onUnmounted, nextTick } from 'vue';
import { isCsrOrAdmin, showMessage } from "../Utilities/Utilities";
import addUserAdmin from "./AddUserAdmin/AddUserAdmin.vue";
import purgedUsers from "./PurgedUsers/PurgedUsers.vue";

interface IData {
    isLoading: Ref<boolean>,
    userList: Ref<UserModel[]>,
    accountSummary: Ref<AccountSummaryModel>,
    showInviteModal: Ref<boolean>,
    showAddModal: Ref<boolean>,
    showDoNotMarket: Ref<boolean>,
    showPurgedUsersModal: Ref<boolean>,
    resetList: Ref<boolean>,
    statusUpdateMessage: Ref<string>,
    showUserDropdown: Ref<number>,
    isCsrOrAdmin: Ref<boolean>,
    isAdmin: Ref<boolean>
}

const getInitialData = function (props: any) {

    return {
        accountSummary: ref<AccountSummaryModel>(props.accountSummary),
        isLoading: ref<boolean>(false),
        userList: ref<UserModel[]>([]),
        showInviteModal: ref<boolean>(false),
        showAddModal: ref<boolean>(false),
        showDoNotMarket: ref<boolean>(false),
        showPurgedUsersModal: ref<boolean>(false),
        resetList: ref<boolean>(false),
        statusUpdateMessage: ref<string>(""),
        showUserDropdown: ref<number>(-1),
        isCsrOrAdmin: ref<boolean>(isCsrOrAdmin()),
        isAdmin: ref<boolean>(props.isAdmin)
    } as IData;
};

const getMethods = function (data: IData, props: any) {
    return {
        sortList: function (userList: UserModel[], sortBy: string) {
            data.userList.value = userList;
        },
        closeDoNotMarket: function () {
            data.showDoNotMarket.value = false;
        },
        closeInvite: async function (msg?: string) {
            data.showInviteModal.value = false;
            if (msg) {
                updateMessage(data, msg);
                await reload(data);
            }
        },
        closeAdd: async function (msg?: string) {
            data.showAddModal.value = false;
            if (msg) {
                updateMessage(data, msg);
                await reload(data);
            }
        },
        closePurgedUsers: function () {
            data.showPurgedUsersModal.value = false;
        },
        saveDoNotMarket: async function () {
            if (!data.isLoading.value) {
                data.isLoading.value = true;

                try {
                    let userManager = await context.getService<IUserManager>('IUserManager');
                    var response = await userManager.doNotMarketUsers(props.accountSummary.id);

                    if (!response || !response.ok) {
                        showMessage("Error setting Do Not Market Users.", "danger", true, true);
                    } else {
                        showMessage("Do Not Market Users successfully set.", "success", true, true);
                        data.showDoNotMarket.value = false;
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    data.isLoading.value = false;
                }
            }
        },
        reloadUserSummary: async function () {
            await reload(data);
        }
    };
}

const reload = async function (data: IData) {
    var userData = await context.getService<IUserData>("IUserData");
    var result = await userData.getAccountsUsersSummary(data.accountSummary.value.ain);
    if (result.ok && result.data) {
        data.userList.value = result.data
    }
}

const updateMessage = function (data: IData, msg: string) {
    data.statusUpdateMessage.value = msg;
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

    setTimeout(hideStatusMessage.bind(null, data), 5000);
}

const hideStatusMessage = function (data: IData) {
    data.statusUpdateMessage.value = '';
}

export default defineComponent({
    name: "Users",
    props: {
        users: Array as () => UserModel[],
        accountSummary: {
            type: Object as () => AccountSummaryModel,
            required: true
        },
        timeZones: {
            type: Array as () => string[],
            required: false
        },
        isAdmin: {
            type: Boolean,
            required: false
        }
    },
    components: {
        "add-user-admin": addUserAdmin,
        "purged-users": purgedUsers
    },
    setup: function (props, ctx) {
        console.log("GS Users setup() props:", props);

        let data = getInitialData(props);
        let methods = getMethods(data, props);

        data.userList.value = props.users ?? [];

        return {
            ...data,
            ...methods
        }
    }
})